import React from "react";
import { curday } from "../../share/upDater/constant";
import { getOldestObject } from "../../../helperJs/helper";
import { ZustandStore } from "../../../store/zustand-store";
import dayjs from "dayjs";

const MapLastUpdate = () => {
  const { selected_date, PREVIOUSALLOLDDATA, SELECTEDPROJECTNEWDATA } =
    ZustandStore((state) => state);

  // Formatting the dates using dayjs
  const formattedDateRange = selected_date
    ? `${dayjs(selected_date.from).format("DD MMM YYYY")} - ${dayjs(
        selected_date.to
      ).format("DD MMM YYYY")}`
    : null;

  const FromDetails = () => {
    return SELECTEDPROJECTNEWDATA[0]?.month
      ? SELECTEDPROJECTNEWDATA[0].month +
          " " +
          SELECTEDPROJECTNEWDATA[0].date +
          ", " +
          SELECTEDPROJECTNEWDATA[0].year
      : false;
  };

  const previousfirstdata =
    PREVIOUSALLOLDDATA &&
    PREVIOUSALLOLDDATA?.map((item) => {
      if (item.data?.length === 0) return [];
      let data = item?.data?.[0];
      data["location"] = item?.location;
      return data;
    });

  const oldestObject = getOldestObject(previousfirstdata);

  const ToDetails = () => {
    return oldestObject
      ? oldestObject?.month +
          " " +
          oldestObject?.date +
          ", " +
          oldestObject?.year +
          " - "
      : false;
  };
  const dataLoadedFrom = `${ToDetails() || ""} ${FromDetails() || curday()}`;
  sessionStorage.setItem("LstUpdtRnkTckgTbl", FromDetails());
  sessionStorage.setItem("DtUpdtRnkTckgTbl", dataLoadedFrom);

  return (
    <>
      {" "}
      {formattedDateRange ? (
        <span className="heading-xs" style={{ color: "#6C6E79" }}>
          ({formattedDateRange})
        </span>
      ) : PREVIOUSALLOLDDATA?.length > 0 ? (
        <span className="heading-xs" style={{ color: "#6C6E79" }}>
          ({dataLoadedFrom})
        </span>
      ) : null}
    </>
  );
};

export default MapLastUpdate;
